import {registerStyle, styleRule, UI} from "../../../../../../stem-core/src/ui/UI";
import {StyleSheet} from "../../../../../../stem-core/src/ui/UI";
import {SubscriptionCoveragePerk, SubscriptionCoverageTitle} from "./CoverageDescriptionElements";
import {PlusIcon} from "../../../../../../core/ui/SVGElements.jsx";


class PlusIconStyle extends StyleSheet {
    @styleRule
    container = {
        margin: "auto",
        padding: "4px 0px",
    }
}

@registerStyle(PlusIconStyle)
class PlusIconElement extends PlusIcon {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            size: 14,
        }
    }
}

const DESCRIPTION_ITEM_TYPE = {
    PERK: "perk",
    PLUS: "plus",
    COVERAGE: "coverage",
};

const descriptionComponentMap = {
    [DESCRIPTION_ITEM_TYPE.PERK]: SubscriptionCoveragePerk,
    [DESCRIPTION_ITEM_TYPE.COVERAGE]: SubscriptionCoverageTitle,
    [DESCRIPTION_ITEM_TYPE.PLUS]: PlusIconElement, // TODO @cleanup this should be a function () => <PlusIcon ... />
};

class CoverageDescriptionStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        flexDirection: "column",
        marginBottom: "auto",
        ">:not(:last-child)": {
            marginBottom: 8,
        },
    }
}

@registerStyle(CoverageDescriptionStyle)
export class CoverageDescription extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            items: [],
        }
    }

    render() {
        return (this.options.items || []).map(item => {
            const DescriptionComponentClass = descriptionComponentMap[item.type];
            return <DescriptionComponentClass {...item} />
        })
    }
}
